import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

//Language File
import common_fr from "./common/translations/fr/common.json";
import common_en from "./common/translations/en/common.json";
import globalConfigurations_en from './common/translations/en/globalConfigurations.json';
import globalConfigurations_fr from './common/translations/fr/globalConfigurations.json';
import employmentBillboard_en from './common/translations/en/employmentBillboard.json';
import employmentBillboard_fr from './common/translations/fr/employmentBillboard.json';
import archive_en from './common/translations/en/archive.json';
import archive_fr from './common/translations/fr/archive.json';

// Common-client2 translations
import common_en2 from "./common-client2/src/translations/enCommon.json";
import common_fr2 from "./common-client2/src/translations/frCommon.json";
import table_en from './common-client2/src/translations/enTable.json';
import table_fr from './common-client2/src/translations/enTable.json';

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        compatibilityJSON: 'v3',
        interpolation: {
            escapeValue: false
        }, // React already does escaping
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'language'
        },
        resources: {
            en: {
                common: common_en, // 'common' is our custom namespace
                common2: common_en, // 'common' is our custom namespace
                employmentBillboard: employmentBillboard_en,
                table: table_en,
                globalConfigurations: globalConfigurations_en,
                archive: archive_en
            },
            fr: {
                common: common_fr,
                common2: common_fr,
                employmentBillboard: employmentBillboard_fr,
                table: table_fr,
                globalConfigurations: globalConfigurations_fr,
                archive: archive_fr
            }
        },
        fallbackLng: 'en'
    });

i18n.addResourceBundle('en', 'common', common_en2, true);
i18n.addResourceBundle('fr', 'common', common_fr2, true);
i18n.loadNamespaces('common');

export default i18n